import React, { useContext, useEffect, useState } from "react";
import Banner from "../../../Utils/Banner/Banner";
import MobileField from "../../../Utils/BasicComponents/MobileField";
import { MyContext } from "../../../context/Context";
import AuthBtn from "../../../Utils/AuthBtn/AuthBtn";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../services/AuthProvider";
import axios from "axios";
import { urlLinks } from "../../../UrlLinks";

export default function Password() {
  const {
    pswd,
    setPswd,
    mobileNumber,
    roleType,
    workerDetails,
    setWorkerDetails,
  } = useContext(MyContext);
  const { passwordSubmit } = useContext(AuthContext);
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");

  const getBindToken = async (userId, jwtToken) => {
    try {
      const bindTokenRes = await axios.post(
        `${urlLinks.baseUrl}/user/${urlLinks.setUserBindToken}?userId=${userId}`,
        {},
        {
          headers: {
            accept: "*/*",
            Authorization: `${jwtToken}`,
          },
        }
      );

      if (bindTokenRes.data.code === 1000) {
        if (bindTokenRes.data.response.bindToken) {
          const token = bindTokenRes.data.response.bindToken;
          localStorage.setItem("authToken", token);
          return true;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkerDetails = async () => {
    try {
      let authToken = localStorage.getItem("authToken");

      const workerResponse = await axios.get(
        `${urlLinks.baseUrl}/worker/getWorkerDetails`,
        {
          headers: {
            accept: "*/*",
            Authorization: `${authToken}`,
          },
        }
      );
      // console.log("workerResponse", workerResponse.data);

      if (workerResponse.data.code === 1005) {
        // await getBindToken(userId, jwtToken);
        // await getWorkerDetails();
      } else if (workerResponse.data.code === 1000) {
        let data = workerResponse.data.response.content[0];
        localStorage.setItem("phone", data.phoneNumber);
        localStorage.setItem(
          "name",
          `${data.firstName}${" "}${data.lastName || ""}`
        );
        localStorage.setItem("ogId", data.okaygoId);
        let profilePhoto = "";
        if (!data.profilePhoto) {
          localStorage.setItem("profilePhoto", "");
          profilePhoto = localStorage.getItem("profilePhoto");
        } else {
          localStorage.setItem("profilePhoto", data.profilePhoto);
          profilePhoto = localStorage.getItem("profilePhoto");
        }

        setWorkerDetails({
          ...workerDetails,
          name: `${data.firstName}${" "}${data.lastName || ""}`,
          ogId: data.okaygoId,
          phone: data.phoneNumber,
          profilePhoto: profilePhoto,
        });

        navigate("/task-page");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const pswdSubmit = async () => {
    setErrorMsg("");
    const jwtToken = await passwordSubmit();
    localStorage.setItem("jwtToken", jwtToken);
    if (!jwtToken) {
      setErrorMsg("Password Not Correct");
    } else {
      try {
        const response = await axios.post(
          `${urlLinks.baseUrl}/user/${urlLinks.addUserRolePhoneNumber}?country_code=91&phone_number=${mobileNumber}&role_type=${roleType}`
        );
        if (response.data.code === 1000) {
          // localStorage.setItem("userId", response.data.response.userId);

          const userId = localStorage.getItem("userId");
          const isTokenStored = await getBindToken(userId, jwtToken);
          if (isTokenStored) {
            await getWorkerDetails();
          }
        } else {
          setErrorMsg("Password Not Correct");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (String(mobileNumber).length === 0) {
      navigate("/login");
    }
  }, [mobileNumber]);

  return (
    <section className="w-full h-full">
      <Banner heading={"Earn higher per hour"} />
      <MobileField
        textField="Enter Password"
        errorMsg={errorMsg}
        pswd={pswd}
        setPswd={setPswd}
      />
      <AuthBtn clickFunction={pswdSubmit} />
    </section>
  );
}
